import React from 'react';
import {connect} from 'react-redux';
import {changeEarringInput} from "../lib/actions";
import {EARRING, MAX_EARRING_LETTERS_PER_LINE} from "../../constants";

class InputHeader extends React.Component {
    getDescription(quantity) {
        switch (quantity) {
            case EARRING.ONE:
                return 'One earring with up to two lines of text (second line is optional).';
            case EARRING.PAIR:
                return 'A pair of earrings with up to two lines of text (second lines are optional).';
        }
    }

    render() {
        return (
            <div className="customizer__header">
                <h4>
                    {this.props.quantity.description}
                </h4>
                <p>{this.getDescription(this.props.quantity)}</p>
            </div>
        );
    }
}

class Input extends React.Component {
    isInvalidInput(value) {
        if (/[^a-zA-Z0-9&]/.test(value)) {
            return true;
        }

        if (value.length && value.length > MAX_EARRING_LETTERS_PER_LINE) {
            return true;
        }

        return false;
    }

    onChange(input, position) {
        if (this.isInvalidInput(input)) return;

        let newInputArray = [...this.props.input];
        newInputArray[position] = input;

        this.props.onInputChange(newInputArray);
    }

    render() {
        let counterClassName = 'customizer-input__count';

        let [earring1line1, earring1line2, earring2line1, earring2line2] = this.props.input;

        if (earring1line1.length === 0) {
            counterClassName += ' customizer-input__count-error';
        }

        if (this.props.quantity === EARRING.PAIR && earring2line1.length === 0) {
            counterClassName += ' customizer-input__count-error';
        }

        return (
            <>
                <InputHeader quantity={this.props.quantity}/>

                <div className='customizer-input'>
                    <div className={this.props.quantity === EARRING.PAIR ? 'customizer-input__half' : 'customizer-input__whole'}>
                        <div className='customizer-input__line'>
                            <label className='customizer-input__label' htmlFor='customizer-input-one'>Line one</label>
                            <input className='customizer-input__field' id='customizer-input-one' type='text' value={earring1line1} onChange={(e) => this.onChange(e.target.value, 0)}/>
                            <div className={counterClassName}>{earring1line1 ? earring1line1.length : 0}/{MAX_EARRING_LETTERS_PER_LINE}</div>
                        </div>
                        <div className='customizer-input__line customizer-input__line--spaced'>
                            <label className='customizer-input__label' htmlFor='customizer-input-two'>Line two</label>
                            <input className='customizer-input__field' id='customizer-input-two' type='text' value={earring1line2} onChange={(e) => this.onChange(e.target.value, 1)}/>
                            <div className='customizer-input__count'>{earring1line2 ? earring1line2.length : 0}/{MAX_EARRING_LETTERS_PER_LINE}</div>
                        </div>
                    </div>
                    {this.props.quantity === EARRING.PAIR &&
                        <div className='customizer-input__half'>
                            <div className='customizer-input__line'>
                                <label className='customizer-input__label' htmlFor='customizer-input-one'>Line one</label>
                                <input className='customizer-input__field' id='customizer-input-one' type='text' value={earring2line1} onChange={(e) => this.onChange(e.target.value, 2)}/>
                                <div className={counterClassName}>{earring2line1 ? earring2line1.length : 0}/{MAX_EARRING_LETTERS_PER_LINE}</div>
                            </div>
                            <div className='customizer-input__line customizer-input__line--spaced'>
                                <label className='customizer-input__label' htmlFor='customizer-input-two'>Line two</label>
                                <input className='customizer-input__field' id='customizer-input-two' type='text' value={earring2line2} onChange={(e) => this.onChange(e.target.value, 3)}/>
                                <div className='customizer-input__count'>{earring2line2 ? earring2line2.length : 0}/{MAX_EARRING_LETTERS_PER_LINE}</div>
                            </div>
                        </div>
                    }
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        input: state.earringInput,
        quantity: state.earringQuantity,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onInputChange: (input) => {
            dispatch(changeEarringInput(input));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Input);
